import { Primary } from '@cinch-labs/design-system'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'

interface StoreCtaButtonProps {
  trackEventTitle: string
  storeName: string
  slug: string
}

export const StoreCtaButton = ({
  slug,
  storeName,
  trackEventTitle,
}: StoreCtaButtonProps) => {
  const { trackEvent } = useAnalytics()

  const handleClick = () => {
    trackEvent({
      eventName: trackEventTitle,
      type: TrackingEventTypes.ADOBE,
      data: {
        action: 'select',
        event: {
          name: EventNames.click,
          type: storeName,
          category: trackEventTitle,
          label: 'search all cars',
        },
      },
    })
    window.open(`/used-cars?store=${slug}`, '_blank')
  }

  return (
    <Primary type="button" data-testid="store-button" onClick={handleClick}>
      {`Search all cars at ${storeName}`}
    </Primary>
  )
}
